<section layoutContent class="new-class-container">
  <!-- Error Alert -->
  <div class="error-alert" *ngIf="errors.length">
    <div class="error-content">
      <svg class="error-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
      </svg>
      <ul class="error-list">
        <li *ngFor="let error of errors" class="error-item">
          {{ error.title }}
        </li>
      </ul>
    </div>
  </div>

  <!-- Información Básica Card -->
  <div class="form-card">
    <div class="card-header">
      <svg class="header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <h2 class="card-title">{{ 'shared-components.new-class.section-basic-info' | translate }}</h2>
    </div>

    <form class="form-content">
      <div class="form-row">
        <div class="form-group">
          <label for="roomLevel" class="form-label">
            <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
            </svg>
            {{ "shared-components.new-class.level" | translate }}
          </label>
          <div
            class="select-wrapper"
            [title]="levelsDisabledReason"
          >
            <select
              [(ngModel)]="room.level"
              class="form-select"
              name="roomLevel"
              id="roomLevel"
              [disabled]="!!levelsDisabledReason"
              [class.form-select--disabled]="!!levelsDisabledReason"
            >
              <option [ngValue]="null">
                {{ "shared-components.new-class.level-empty" | translate }}
              </option>
              <option
                *ngIf="!!levelsDisabledReason"
                [ngValue]="null"
                disabled
              >
                {{ levelsDisabledReason }}
              </option>
              <option
                *ngFor="let option of levels"
                [ngValue]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <svg class="select-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="name" class="form-label">
            <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
            </svg>
            {{ "shared-components.new-class.name" | translate }}
          </label>
          <input
            class="form-input"
            [(ngModel)]="room.name"
            name="name"
            type="text"
            id="name"
            [placeholder]="'shared-components.new-class.name-placeholder' | translate"
          />
        </div>
      </div>
    </form>
  </div>

  <!-- Configuración de Clase Card -->
  <div class="form-card">
    <div class="card-header">
      <svg class="header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
      </svg>
      <h2 class="card-title">{{ 'shared-components.new-class.section-class-config' | translate }}</h2>
    </div>

    <form class="form-content">
      <div class="form-row">
        <div class="form-group">
          <label for="roomProgram" class="form-label">
            <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
            {{ "shared-components.new-class.program" | translate }}
          </label>
          <div class="select-wrapper">
            <select
              [(ngModel)]="room.questionary"
              class="form-select"
              name="roomProgram"
              id="roomProgram"
            >
              <option value="" disabled selected>
                {{ "shared-components.new-class.program-placeholder" | translate }}
              </option>
              <option
                *ngFor="let option of programs"
                [ngValue]="option.value"
                [selected]="option.value === room.questionary"
              >
                {{ option.label }}
              </option>
            </select>
            <svg class="select-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="roomProfesor" class="form-label">
            <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
            {{ "shared-components.new-class.teacher" | translate }}
          </label>
          <div class="select-wrapper">
            <select
              [(ngModel)]="room.teacher"
              class="form-select"
              name="roomProfesor"
              id="roomProfesor"
            >
              <option value="" disabled selected>
                {{ "shared-components.new-class.teacher-placeholder" | translate }}
              </option>
              <option
                *ngFor="let option of teachers"
                [ngValue]="option.value"
                [selected]="room.teacher === option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <svg class="select-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="roomReport" class="form-label">
            <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            {{ "shared-components.new-class.report" | translate }}
          </label>
          <div class="select-wrapper">
            <select
              [(ngModel)]="room.report"
              class="form-select"
              name="roomReport"
              id="roomReport"
            >
              <option value="" disabled selected>
                {{ "shared-components.new-class.report-placeholder" | translate }}
              </option>
              <option
                *ngFor="let option of reports"
                [ngValue]="option.value"
                [selected]="option.value === room.report"
              >
                {{ option.label }}
              </option>
            </select>
            <svg class="select-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
      </div>

    </form>
  </div>
</section>
